import _ from 'lodash';
import bffcli from '../bffcli';

const errorHandler = err => {
  console.log(err);
};

export const getSavedDrugs = async () => {
  try {
    const savedDrugs = await bffcli.get('/drug/getSavedDrugs');
    if (!_.isEmpty(savedDrugs.data)) {
      return savedDrugs.data;
    }
  } catch (err) {
    errorHandler(err);
    return false;
  }
};

export const saveUserDrug = async (ndc, quantity, isCustomQuantity) => {
  try {
    const saveUserDrugResponse = await bffcli.post('/drug/saveUserDrug', {
      ndc,
      quantity,
      isCustomQuantity
    });
    if (!_.isEmpty(saveUserDrugResponse.data)) {
      return saveUserDrugResponse.data;
    }
  } catch (err) {
    errorHandler(err);
    return false;
  }
};

export const editSavedDrug = async (
  drugId,
  ndc,
  quantity,
  saveDrugId,
  isCustomQuantity
) => {
  try {
    const editSavedDrugResponse = await bffcli.post('/drug/editSavedDrug', {
      drugId,
      ndc,
      quantity,
      saveDrugId,
      isCustomQuantity
    });
    if (!_.isEmpty(editSavedDrugResponse.data)) {
      return editSavedDrugResponse.data;
    }
  } catch (err) {
    errorHandler(err);
    return false;
  }
};

export const deleteSavedDrug = async (savedDrugId, drugItemid) => {
  try {
    const deleteSavedDrugResponse = await bffcli.post('/drug/deleteSavedDrug', {
      savedDrugId,
      drugItemid
    });
    if (!_.isEmpty(deleteSavedDrugResponse.data)) {
      return deleteSavedDrugResponse.data;
    }
  } catch (err) {
    errorHandler(err);
    return false;
  }
};

export const deleteAllDrugs = async savedDrugId => {
  try {
    const deleteAllDrugsResponse = await bffcli.post('/drug/deleteAllDrugs', {
      savedDrugId
    });
    if (!_.isEmpty(deleteAllDrugsResponse.data)) {
      return deleteAllDrugsResponse.data;
    }
  } catch (err) {
    errorHandler(err);
    return false;
  }
};
